export default __webpack_public_path__ + "static/media/EnglishHoweTrussImg.96bd1a4f.png";